import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-collect",
  "use": "icon-collect-usage",
  "viewBox": "0 0 1086 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1086 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-collect\"><defs><style type=\"text/css\"></style></defs><path d=\"M1083.525992 398.385345a53.574479 53.574479 0 0 0-43.244252-37.039912l-308.821039-54.350021-139.597657-277.30299a54.287978 54.287978 0 0 0-96.508514 0l-138.20168 277.30299-308.821039 55.839063a53.760609 53.760609 0 0 0-31.642136 92.165475L241.969272 661.511417l-57.917517 299.390442a54.070826 54.070826 0 0 0 21.715191 52.736893 58.444886 58.444886 0 0 0 57.141975 3.939756l280.281073-137.084899 279.505531 137.084899a54.101848 54.101848 0 0 0 78.764101-56.707671l-56.366432-299.390441 223.139099-207.845401a53.481413 53.481413 0 0 0 15.510851-55.156585z m0 0\" p-id=\"2960\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/collect.svg
// module id = roky
// module chunks = 17